import { getCaptchaToken } from "./captchaHelpers";
export default class IcaFileRequestHelpers {
    isAuthenticated?: boolean;
    token?: string;
    username?: string;
    password?: string;
    passcode?: string;
    requestToken?: boolean;
    isMobile?: boolean;
    redirectionUrl?: string;
    hasSharedPassword?: boolean;
    disableReputation?: boolean;
    reputationToken?: string;
    browserId?: string;
    receiverVersion?: string;
    fastLaunch?: boolean = true;

    haveToken = (): boolean => {
        return !!this.token;
    }

    getRequest = (params: IcaFileRequestHelpers) => {
        let rtn = new IcaFileRequestHelpers();
        let action: string;

        if (!params.isAuthenticated && !params.hasSharedPassword) {
            action = 'Unauthenticated';
            rtn.isAuthenticated = false;
        } else if (params.haveToken()) {
            action = 'RememberMe';
            rtn.isAuthenticated = !params.hasSharedPassword;
            rtn.token = params.token;
        } else {
            rtn.isAuthenticated = !params.hasSharedPassword;
            rtn.username = params.username;
            rtn.requestToken = params.requestToken;
            rtn.password = params.password;

            action = !params.hasSharedPassword ? 'Authenticated' : 'SharedPasscode';
        }

        if (params.redirectionUrl) {
            rtn.redirectionUrl = params.redirectionUrl;
        }

        rtn.isMobile = params.isMobile;
        rtn.browserId = params.browserId;
        rtn.receiverVersion = params.receiverVersion;
        rtn.fastLaunch = params.fastLaunch;

        if (params.disableReputation) {
            action = 'Disabled';
        }

        return getCaptchaToken(action)
            .then((token: string) => {
                rtn.reputationToken = token;
                return rtn;
            })
            .catch((error) => {
                console.error("Error obtaining reCAPTCHA token:", error); // This will run when rejected
            });
    }
}
